window.customUID = (is_personalize) => {
  const length = 16;
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length);
    result += chars[randomIndex];
  }
  
  let uidElements = document.querySelectorAll("[name='properties[uid]']");
  uidElements.forEach(function(ele){
    ele.value = result;
  });
  
  let linkElements = document.querySelectorAll("[name='properties[link_to]']");
  linkElements.forEach(function(ele){
    ele.value = result;
  });

  if(!is_personalize){
    let pdpUID = document.querySelector("[data-pdp-uid]");
    if(pdpUID){
      pdpUID.value = "";
    }
  }
  return result;
}

const personalizeButtons = document.querySelectorAll("[data-personalise-btn]");
personalizeButtons.forEach((button) => {
  button.addEventListener("click", (event) => {
    const personalizeDrawerParent = event.target.parentNode;
    const personalizeDrawer = personalizeDrawerParent.querySelector(".product_customization_drawer");

    //-Drawer quiz swiper process.
    const swiper = new Swiper(personalizeDrawer.querySelector(".swiper-container"), {
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      allowTouchMove: false,
    });
    
    function checkCurrentRadioButton() {
      const currentSlide = swiper.slides[swiper.activeIndex];
      const radioInputs = currentSlide.querySelectorAll('input[type="radio"]');
      const isAnyChecked = Array.from(radioInputs).some((input) => input.checked);
      personalizeDrawer.querySelector(".swiper-button-next").style.display = isAnyChecked ? "block" : "none";
    }
    
    swiper.on("slideChange", () => {
      const quizContainer = personalizeDrawer.querySelector(".quizContainer");
      const lastSlideIndex = swiper.slides.length - 1;
      quizContainer.classList.toggle("on-last-slide", swiper.activeIndex === lastSlideIndex);
    
      checkCurrentRadioButton()
    });

    personalizeDrawer.querySelectorAll('.quizSliderQues input[type="radio"]').forEach((input) => {
      input.addEventListener("input", () => {
        if(input.checked) 
          swiper.slideNext();
        
        checkCurrentRadioButton();
      });
    });

    personalizeDrawer.querySelector("#restart_quiz").addEventListener("click", function () {
      swiper.slideTo(0);
      personalizeDrawer.querySelectorAll('.quizSliderQues input[type="radio"]').forEach((input) => {
        input.checked = false;
      });
      personalizeDrawer.querySelector(".swiper-button-next").style.display = "none";
    });

    //-Drawer quiz result process.
    function updateResult() {
      const step1Value = personalizeDrawer.querySelector('input[name="occasion"]:checked')?.value || "";
      const step2Value = personalizeDrawer.querySelector('input[name="recipient"]:checked')?.value || "";
      const step3Value = personalizeDrawer.querySelector('input[name="tone"]:checked')?.value || "";
      const result = `${step1Value}_${step2Value}_${step3Value}`;
      
      fetch(window.Shopify.routes.root + `search/suggest?q=${result.replace(/[^a-zA-Z0-9_\s]/g, "").toLowerCase()}&section_id=quick-suggetions`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const content = html.querySelector("[data-result-suggetion]");
          if (content) {
            personalizeDrawer.querySelector("[quiz-results]").innerHTML = content.innerHTML ? content.innerHTML : "No suggestion available for selected options.";
          } else {
            console.error("No section found.");
          }
        })
        .catch((error) => console.error("Error fetching section:", error));
    }
    const radioButtons = personalizeDrawer.querySelectorAll('.quizBodyContainer input[type="radio"]');
    radioButtons.forEach((radio) => {
      radio.addEventListener("change", updateResult);
    });
    updateResult();

    
    //-Drawer open process.
    personalizeDrawer.classList.add("opened");
    personalizeDrawerParent.querySelector(".p_c_drawer_overlay").classList.add("activeOverlay");
    personalizeDrawer.querySelector(".topBarQuiz").classList.remove("hidden");
    personalizeDrawer.querySelector(".quizContainerHeader").classList.add("hidden");
    personalizeDrawer.querySelector(".quizBody").classList.add("hidden"); 
    personalizeDrawer.querySelectorAll('.quizSliderQues input[type="radio"]').forEach((input) => {
      input.checked = false;
    });
    personalizeDrawer.querySelector('[data-personlizer-id="complementary_text_style"]').value = "";
    document.body.style.overflow = "hidden";
    document.body.classList.add("popup_customizer_opened");
    personalizeDrawer.closest("section").classList.add("popupSection");

    const engrave = personalizeDrawer.querySelector(".engraving_characters");
    const engraveInput = engrave.querySelector("input");
    const charLimit = engraveInput.getAttribute("data-limit");
    engrave.querySelector(".counter").textContent = `0/${charLimit} characters`;
    engraveInput.value = "";
    personalizeDrawer.querySelector(".canvas_btn_positions .js-default").click();

    //-Drawer input char process.
    engraveInput.addEventListener("input", function () {
    let allowedChars = /^[a-zA-Z0-9 .,!?'\-\"&():;/#@]*$/;
    let errorMessageElement = document.querySelector(".special_characters");

    // Check if the input contains any restricted characters
    if (!allowedChars.test(engraveInput.value)) {
        engraveInput.value = engraveInput.value.replace(/[^a-zA-Z0-9 .,!?'"\-&():;/#@]/g, "");
        errorMessageElement.innerHTML = `Supported Characters for Engraving: English Letters (A-Z, a-z), Digits (0-9), Standard Special Characters: . , ! ? ' " - & () : ; / # @`;
        errorMessageElement.style.display = "block"; // Show error message
    } else {
        errorMessageElement.style.display = "none"; // Hide error message when input is valid
    }

    // Limit input length to 40 characters
    if (engraveInput.value.length > 40) {
        engraveInput.value = engraveInput.value.substring(0, 40);
    }

    // Update character counter
    engrave.querySelector(".counter").textContent = `${engraveInput.value.length}/40 characters`;
});



    //-Drawer accept_continue process.
    personalizeDrawer.querySelector(".step_1personalize").addEventListener("click", function () {
      personalizeDrawer.querySelector(".product_customization_step_1").classList.remove("product_customization_active");
      personalizeDrawer.querySelector(".product_customization_step_2").classList.add("product_customization_active");
      personalizeDrawer.querySelector("[data-personlizer-id=complementary_laser_personlizer]").checked = true;

      if(!personalizeDrawer.querySelector("#containerProductCanvas canvas")){
        const instance = new window.KNIFEPREVIEW({
          dom: personalizeDrawer.querySelector("#containerProductCanvas"),
          debug: false,
          defaultText: "Your Personalised Message Engraved Here",
          defaultFont: "modern"
        });
        
        const interval = setInterval(() => {
          if (personalizeDrawer.querySelector("#containerProductCanvas canvas")) {
            clearInterval(interval);
          }
        }, 4000);
        
        personalizeDrawer.querySelector("[data-personlizer-id='complementary_text_style']")?.addEventListener("input", function (e) {
            instance.settings.text = e.target.value;
            instance.engrave();
        });
        personalizeDrawer.querySelectorAll("[data-personlizer-id='complementary_font_style']").forEach((radio) => {
          radio.addEventListener("change", function (e) {
            if (e.target.checked) {
              instance.settings.font = e.target.value;
              instance.engrave();
            }
          });
        });
    
        personalizeDrawer.querySelectorAll('.canvas_btn_positions .button').forEach(button => {
          button.addEventListener('click', () => {
            personalizeDrawer.querySelectorAll('.canvas_btn_positions .button').forEach(btn => {
              btn.classList.remove('active');
            });
            button.classList.add('active');
            
            if(button.classList.contains("js-default")){ instance.defaultView() }
            if(button.classList.contains("js-back")){ instance.backView() }
            if(button.classList.contains("js-top")){ instance.topView() }
          });
        });
        
      }else{
        personalizeDrawer.querySelector("[data-personlizer-id=complementary_text_style]").value = "";
        const changeEvent = new Event('input', { bubbles: true });
        personalizeDrawer.querySelector("[data-personlizer-id=complementary_text_style]").dispatchEvent(changeEvent);
      }
    });

    //-Drawer cart process.
    personalizeDrawer.querySelector("#add_to_cart_btn").addEventListener("click", (event) => {
      personalizeDrawer.querySelector("#textError").textContent = "";
      personalizeDrawer.querySelector("#radioError").textContent = "";
    
      const textInput = personalizeDrawer.querySelector(".engraving_characters input");
      const isTextInputValid = () => textInput.value.trim() !== "";
    
      if (!isTextInputValid()) {
        event.preventDefault();
        personalizeDrawer.querySelector("#textError").textContent = "This field is required.";
        personalizeDrawer.querySelector("#textError").style.color = "red";
      }
    });

    //-Drawer quiz button behaviour.
    var startquiz = personalizeDrawer.querySelector(".take_the_quiz");
    var quizheader = personalizeDrawer.querySelector(".quizContainerHeader");
    var quizbody = personalizeDrawer.querySelector(".quizBody");
    var hidequiz_btn = personalizeDrawer.querySelector(".topBarQuiz");
    startquiz.addEventListener("click", function () {
      hidequiz_btn.classList.add("hidden");
      quizheader.classList.remove("hidden");
      quizbody.classList.remove("hidden");
    });

    //-Drawer close process.
    const closeTriggers = personalizeDrawerParent.querySelectorAll(".drawer__close-button, .p_c_drawer_overlay");
    closeTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        personalizeDrawer.classList.remove("opened");
        personalizeDrawerParent.querySelector(".p_c_drawer_overlay").classList.remove("activeOverlay");
        personalizeDrawer.querySelector(".product_customization_step_1").classList.add("product_customization_active");
        personalizeDrawer.querySelector(".product_customization_step_2").classList.remove("product_customization_active");
        personalizeDrawer.querySelectorAll('.quizSliderQues input[type="radio"]').forEach((input) => {
          input.checked = false;
        });
        document.body.style.overflow = "auto";
        personalizeDrawer.querySelector("#textError").textContent = "";
        personalizeDrawer.querySelector("#radioError").textContent = "";
        setTimeout(function(){ 
          document.body.classList.remove("popup_customizer_opened");
          personalizeDrawer.closest("section").classList.remove("popupSection");
        },500);
        personalizeDrawer.querySelector("[data-personlizer-id=complementary_laser_personlizer]").checked = false;

        if (typeof swiper !== "undefined" && swiper.slideTo) {
          swiper.slideTo(0);
        }
      });
    });

  });
});

document.addEventListener("click", function (event) {
  let suggetionCount = event.target.hasAttribute("data-suggetion-count");
  if (suggetionCount) {
    document.querySelector(".product_customization_drawer.opened [data-personlizer-id=complementary_text_style]").value = event.target.textContent;
    
    const changeEvent = new Event('input', { bubbles: true });
    document.querySelector(".product_customization_drawer.opened [data-personlizer-id=complementary_text_style]").dispatchEvent(changeEvent);

    let charCount = event.target.textContent.length;
    document.querySelector(".product_customization_drawer.opened .counter").textContent = `${charCount}/40 characters`;
  }
});

// on change updating free product price in personalize popup and product page
var set_product_price = document.querySelector("[data-custom-id='complementary_laser']");
const labelElement = document.querySelector("label[free-product-price]");
var getproductpriceElements = document.querySelectorAll(".custom_variant_price");
var originalPrice = parseFloat(
  getproductpriceElements[0]?.textContent
    .replace("$", "")
    .replace("AUD", "")
    .trim()
);
set_product_price?.addEventListener("change", function () {
  if (set_product_price.checked) {
    const freeProductPrice = parseFloat(
      labelElement.getAttribute("free-product-price").replace("$", "")
    );
    const productPrice = originalPrice;
    const totalPrice = freeProductPrice + productPrice; 
    getproductpriceElements?.forEach(function (element) {
      element.textContent = `$${totalPrice.toFixed(2)} AUD`;
    });
  } else {
    getproductpriceElements?.forEach(function (element) {
      element.textContent = `$${originalPrice.toFixed(2)} AUD`;
    });
  }
});
document.addEventListener("DOMContentLoaded", (event) => {
  window.customUID(true);
});


// check the input of outsise the popup 
// Function to validate input and textarea fields
 document.addEventListener("DOMContentLoaded", () => {
  const allowedCharactersRegex = /^[a-zA-Z0-9 .,!?'\-"&():;/#@]*$/;

  // Function to sanitize input
  const sanitizeInput = (input) => input.replace(/[^a-zA-Z0-9 .,!?'\-"&():;/#@]/g, "");

  // Event listener for input and paste events
  document.addEventListener("input", (event) => {
    if (event.target.classList.contains("textarea")) {
      const textarea = event.target;
      const errorMessage = textarea.nextElementSibling;

      const sanitizedValue = sanitizeInput(textarea.value);

      if (textarea.value !== sanitizedValue) {
        textarea.value = sanitizedValue;
        errorMessage.style.display = "block";
      } else {
        errorMessage.style.display = "none";
      }
    }
  });

  document.addEventListener("paste", (event) => {
    if (event.target.classList.contains("textarea")) {
      const errorMessage = event.target.nextElementSibling;
      const pastedText = (event.clipboardData || window.clipboardData).getData("text");
      const sanitizedPastedText = sanitizeInput(pastedText);

      if (pastedText !== sanitizedPastedText) {
        event.preventDefault();
        errorMessage.style.display = "block";
      }
    }
  });
});

